import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react';
import { Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from 'react-utils/hooks/usePrevious';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import { getRecommendations, getTopicPreferences // @ts-expect-error Could not find a declaration file for module
} from '../actions/RecommendationsActions'; // @ts-expect-error Could not find a declaration file for module

import { getTracksAreRequesting } from '../selectors/trackSelectors'; // @ts-expect-error Could not find a declaration file for module

import { getLessonsAreRequesting } from '../selectors/lessonSelectors'; // @ts-expect-error Could not find a declaration file for module

import { useFetchTracksLessonsData } from '../hooks/catalogPageHooks';
import MostPopularCertificates from '../components/MostPopularCertificates/MostPopularCertificates';
import FeaturedSoftwareCoursesSection from '../components/FeaturedSoftwareCoursesSection/FeaturedSoftwareCoursesSection'; // @ts-expect-error Could not find a declaration file for module

import HomePageLayout from '../components/Layouts/HomePageLayout';
import { useRecommendations, useRecommendationsTopicPreference } from '../features/recommendations';

const Homepage = () => {
  const dispatch = useDispatch();
  const isRequestingTracksOrLessons = useSelector(state => getTracksAreRequesting(state) || getLessonsAreRequesting(state));
  const {
    recommendationsLoading
  } = useRecommendations();
  const {
    recommendationsTopicPreference,
    recommendationsTopicPreferenceLoading
  } = useRecommendationsTopicPreference();
  const hasError = useSelector(state => state.tracks.get('hasError'));
  const recentError = useSelector(state => state.tracks.get('recentError'));
  useFetchTracksLessonsData();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.HOME
    });
    dispatch(getTopicPreferences());
    dispatch(getRecommendations());
  }, [dispatch]);
  const previousSavedTopicPreference = usePrevious(recommendationsTopicPreference);
  useEffect(() => {
    if (previousSavedTopicPreference && previousSavedTopicPreference !== recommendationsTopicPreference) {
      dispatch(getRecommendations());
    }
  }, [dispatch, previousSavedTopicPreference, recommendationsTopicPreference]);
  return /*#__PURE__*/_jsx(HomePageLayout, {
    error: hasError ? recentError : null,
    footerComponent: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(MostPopularCertificates, {}), /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSection, {})]
    }),
    children: !hasError && !isRequestingTracksOrLessons ? /*#__PURE__*/_jsx(Fragment, {
      children: !recommendationsLoading && !recommendationsTopicPreferenceLoading && /*#__PURE__*/_jsx(NavMarker, {
        name: "HOMEPAGE_RECOMMENDATIONS_LOADED"
      })
    }) : null
  });
};

export default Homepage;